module.exports = __webpack_public_path__ + "static/media/learning_mode.581a9815.gif";